export const inspectionsData = [
  {
    key: "1",
    CAR: "Ford Endeavour",
    MODAL: "Sedan",
    IMAGE: "car-01.jpg",
    INSPECTEDSTATUS: "Completed",
    INSPECTIONDATE: "24 Jan 2025",
    INSPECTEDBY: "Shaun Farley",
    INSPECTEDIMAGE: "avatar-01.jpg",
    REPAIRSTATUS: "Completed",
  },
  {
    key: "2",
    CAR: "Ferrari 458 MM",
    MODAL: "Convertible",
    IMAGE: "car-02.jpg",
    INSPECTEDSTATUS: "Inprogress",
    INSPECTIONDATE: "19 Dec 2024",
    INSPECTEDBY: "Jenny Ellis",
    INSPECTEDIMAGE: "avatar-12.jpg",
    REPAIRSTATUS: "Pending",
  },
  {
    key: "3",
    CAR: "Ford Mustang",
    MODAL: "Coupe",
    IMAGE: "car-03.jpg",
    INSPECTEDSTATUS: "Completed",
    INSPECTIONDATE: "11 Dec 2024",
    INSPECTEDBY: "Leon Baxter",
    INSPECTEDIMAGE: "avatar-15.jpg",
    REPAIRSTATUS: "Need Repair",
  },
  {
    key: "4",
    CAR: "Toyota Tacoma 4",
    MODAL: "Hatchback",
    IMAGE: "car-04.jpg",
    INSPECTEDSTATUS: "Pending",
    INSPECTIONDATE: "29 Nov 2024",
    INSPECTEDBY: "Karen Flores",
    INSPECTEDIMAGE: "avatar-17.jpg",
    REPAIRSTATUS: "Inprogress",
  },
  {
    key: "5",
    CAR: "Chevrolet Truck",
    MODAL: "Sedan",
    IMAGE: "car-05.jpg",
    INSPECTEDSTATUS: "Completed",
    INSPECTIONDATE: "03 Nov 2024",
    INSPECTEDBY: "Michael Dawson",
    INSPECTEDIMAGE: "avatar-06.jpg",
    REPAIRSTATUS: "Completed",
  },
  {
    key: "6",
    CAR: "Etios Carmen",
    MODAL: "Hatchback",
    IMAGE: "car-06.jpg",
    INSPECTEDSTATUS: "On Hold",
    INSPECTIONDATE: "31 Oct 2024",
    INSPECTEDBY: "Karen Galvan",
    INSPECTEDIMAGE: "avatar-18.jpg",
    REPAIRSTATUS: "On Hold",
  },
  {
    key: "7",
    CAR: "Acura Sport",
    MODAL: "Crossover",
    IMAGE: "car-07.jpg",
    INSPECTEDSTATUS: "Completed",
    INSPECTIONDATE: "15 Oct 2024",
    INSPECTEDBY: "Thomas Ward",
    INSPECTEDIMAGE: "avatar-03.jpg",
    REPAIRSTATUS: "Completed",
  },
  {
    key: "8",
    CAR: "Kia Soul 2016",
    MODAL: "Delivery",
    IMAGE: "car-08.jpg",
    INSPECTEDSTATUS: "Rejected",
    INSPECTIONDATE: "26 Sep 2024",
    INSPECTEDBY: "Aliza Duncan",
    INSPECTEDIMAGE: "avatar-17.jpg",
    REPAIRSTATUS: "Need Repair",
  },
  {
    key: "9",
    CAR: "Camaro",
    MODAL: "Station Wagon",
    IMAGE: "car-09.jpg",
    INSPECTEDSTATUS: "Completed",
    INSPECTIONDATE: "01 Sep 2024",
    INSPECTEDBY: "James Higham",
    INSPECTEDIMAGE: "avatar-05.jpg",
    REPAIRSTATUS: "Completed",
  },
  {
    key: "10",
    CAR: "Toyota Camry",
    MODAL: "Mini Van",
    IMAGE: "car-10.jpg",
    INSPECTEDSTATUS: "Completed",
    INSPECTIONDATE: "15 Aug 2024",
    INSPECTEDBY: "Jade Robinson",
    INSPECTEDIMAGE: "avatar-08.jpg",
    REPAIRSTATUS: "Completed",
  },
];
